export function getActiveTextOverlays(overlays, timeSec) {
  if (!overlays) return [];
  return overlays.filter(o => timeSec >= o.startTime && timeSec < o.endTime);
}

export function createTextOverlay(startTime = 0, endTime = 3, x = 0.5, y = 0.5) {
  return {
    id: `txt-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
    text: 'Your text here',
    startTime, endTime, x, y,
    style: {
      fontFamily: 'Inter, sans-serif', fontSize: 32, fontWeight: 700,
      color: '#ffffff', background: '', borderRadius: 0, padding: '0',
      textShadow: '2px 2px 8px rgba(0,0,0,0.6)', letterSpacing: 0,
      textTransform: 'none', textAlign: 'center', lineHeight: 1.3,
    },
    animation: { enter: 'fadeIn', exit: 'fadeOut', enterDuration: 0.5, exitDuration: 0.4 },
  };
}
